import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App/App";

import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";
import "@fontsource/manrope/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";

import "./styles/tokens.css";
import "./styles/global.css";
import "./styles/touch.css";

const root = createRoot(document.getElementById("root"));
root.render(<App />);
